import { render } from "./DropdownMenu.vue?vue&type=template&id=718e8f10"
import script from "./DropdownMenu.vue?vue&type=script&lang=js"
export * from "./DropdownMenu.vue?vue&type=script&lang=js"

import "./DropdownMenu.vue?vue&type=style&index=0&id=718e8f10&lang=sass"
script.render = render

export default script